import { useYearQuarterNavigation } from 'hooks';
import { useTranslation } from 'react-i18next';

import { FunctionCapacityBalance } from 'components/types';

import { Box, Table, TableBody, TableCell, TableHead } from '@mui/material';

import { NumericTableCell, TableHeaderRow } from 'components/shared/Table';

import { renderPeriodColumnHeaders } from '../../../util';
import DetailRow from './DetailRow';

type Props = {
  functionCapacityBalances: FunctionCapacityBalance[];
};

const DetailTable = ({ functionCapacityBalances }: Props) => {
  const { t } = useTranslation('common');
  const { isViewPerWeek } = useYearQuarterNavigation();
  const { periodHourBalances } = functionCapacityBalances[0];
  const functions = [...functionCapacityBalances].sort((a, b) =>
    a.function && b.function
      ? a.function?.description.localeCompare(b.function?.description)
      : -1
  );

  return (
    <Table stickyHeader size="small">
      <TableHead>
        <TableHeaderRow>
          <TableCell width={200}>
            <Box pl="44px">{t('function')}</Box>
          </TableCell>
          {renderPeriodColumnHeaders(periodHourBalances, isViewPerWeek)}
          <NumericTableCell width={68}>{t('formation.total')}</NumericTableCell>
        </TableHeaderRow>
      </TableHead>
      <TableBody>
        {functions.map((functionCapacityBalance) => (
          <DetailRow
            key={functionCapacityBalance.uuid}
            functionCapacityBalance={functionCapacityBalance}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default DetailTable;
